<div class="floating-container">
  <mat-spinner
    *ngIf="isLoading && !isError"
    class="floating-spinner"
  ></mat-spinner>
  <div *ngIf="!isLoading && !isError && !isOutdated && !_orderPhoneUrl.length">
    <div class="logo-image-holder">
      <img
        src="{{ imageSource }}"
        class="logo-image"
        onerror="this.src='/assets/img/placeholder.png'"
      />
    </div>
    <div class="small-margin">
      <p class="floating-text">
        {{ worktimeString
        }}<button mat-icon-button color="accent" (click)="showWorkTime()">
          <mat-icon>help_outline</mat-icon>
        </button>
      </p>
    </div>
    <div *ngIf="isSuccess">
      <div class="small-margin">
        <button
          mat-raised-button
          color="primary"
          class="fill-parent-width"
          (click)="orderNow()"
        >
          <mat-icon *ngIf="showCoupons === true"
            ><img src="/assets/img/coupon_icon.png" style="height: 100%"
          /></mat-icon>
          {{ orderNowString }}
        </button>
      </div>
      <div *ngIf="showProfile" class="small-margin">
        <button
          mat-raised-button
          color="primary"
          (click)="seeProfile()"
          class="fill-parent-width"
        >
          {{ myProfileButtonString }}
        </button>
      </div>
      <div *ngIf="showApp" class="small-margin">
        <button
          mat-raised-button
          color="primary"
          (click)="openApp()"
          class="fill-parent-width"
        >
          {{ appButtonString }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isError" class="small-logo-holder" (click)="contactUs()">
    <img src="/assets/img/snacktimelogo.png" class="small-logo" />
  </div>
  <div *ngIf="isError">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ errortitle }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ errormessage }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-raised-button
          color="accent"
          class="fill-parent-width"
          (click)="tryAgain()"
        >
          {{ errorbutton }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div *ngIf="isOutdated && !_orderPhoneUrl.length && !isLoading">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Ola</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Você esta acessando uma versão antiga de nossa aplicação. Veja abaixo
          como resolver.
        </p>
        <p>Acesse:</p>
        <a href="https://jurasmenu.com.br">https://jurasmenu.com.br</a>
        <p>ou</p>
        <a href="https://snacktime.com.br/juras">
          https://snacktime.com.br/juras
        </a>
        <div style="height: 20px"></div>
        <p>
          Caso esteja vendo essa mensagem no aplicativo. Verifique se o
          aplicativo esta atualizado.
        </p>
        <div style="height: 20px"></div>
        <button mat-flat-button (click)="getSupport()" color="accent">
          <mat-icon>chat</mat-icon>
          <span>Fale Conosco</span>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
  <div *ngIf="!isOutdated && _orderPhoneUrl.length && !isLoading">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Olá</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Os pedidos agora são feitos pelo Whatsapp.</p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
